import { Reducer } from 'redux';
import {
  initialState,
  InsightsGlobalFilterAction,
  InsightsGlobalFilterTypes,
  State,
  UserAction,
  UserTypes,
} from '../types';

const getInsightsGlobalFilters: Reducer<
  State['insightsGlobalFilters'],
  InsightsGlobalFilterAction
> = (
  state: State['insightsGlobalFilters'] = initialState.insightsGlobalFilters,
  action: InsightsGlobalFilterAction | UserAction,
): State['insightsGlobalFilters'] => {
  switch (action.type) {
    case InsightsGlobalFilterTypes.UPDATE_ORGANISATIONAL_SITES:
      return {
        ...state,
        organisational: {
          ...state.organisational,
          sites: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_ORGANISATIONAL_COUNTRIES:
      return {
        ...state,
        organisational: {
          ...state.organisational,
          countries: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_ORGANISATIONAL_CASE_COUNTRY_CODES:
      return {
        ...state,
        organisational: {
          ...state.organisational,
          caseCountryCodes: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_ORGANISATIONAL_CASE_REGION_IDS:
      return {
        ...state,
        organisational: {
          ...state.organisational,
          caseRegionIds: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_ORGANISATIONAL_TIME:
      return {
        ...state,
        organisational: {
          ...state.organisational,
          time: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_ORGANISATIONAL_GLOBAL_LOCATION_FILTER:
      return {
        ...state,
        organisational: {
          ...state.organisational,
          currentGlobalLocationFilter: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_ORGANISATIONAL_LOCATION_FILTER_CATEGORY:
      return {
        ...state,
        organisational: {
          ...state.organisational,
          locationFilterCategory: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_TOP_DEPARTMENTS:
      return {
        ...state,
        organisational: {
          ...state.organisational,
          topDepartments: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_OPERATIONAL_SITES:
      return {
        ...state,
        operational: {
          ...state.operational,
          sites: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_OPERATIONAL_COUNTRIES:
      return {
        ...state,
        operational: {
          ...state.operational,
          countries: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_OPERATIONAL_CASE_COUNTRY_CODES:
      return {
        ...state,
        operational: {
          ...state.operational,
          caseCountryCodes: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_OPERATIONAL_CASE_REGION_IDS:
      return {
        ...state,
        operational: {
          ...state.operational,
          caseRegionIds: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_OPERATIONAL_TIME:
      return {
        ...state,
        operational: {
          ...state.operational,
          time: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_OPERATIONAL_GLOBAL_LOCATION_FILTER:
      return {
        ...state,
        operational: {
          ...state.operational,
          currentGlobalLocationFilter: action.payload,
        },
      };
    case InsightsGlobalFilterTypes.UPDATE_OPERATIONAL_LOCATION_FILTER_CATEGORY:
      return {
        ...state,
        operational: {
          ...state.operational,
          locationFilterCategory: action.payload,
        },
      };
    case UserTypes.CLEAR_SESSION:
      return {
        ...state,
        ...initialState.insightsGlobalFilters,
      };
    default:
      return state;
  }
};

export default getInsightsGlobalFilters;
